var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filter_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.733,
    height: 14.175,
    viewBox: "0 0 17.733 14.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9201",
    "data-name": "Group 9201",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9202",
    "data-name": "Group 9202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3231",
    "data-name": "Rectangle 3231",
    transform: "translate(1.363)",
    fill: "#4c96ce",
    stroke: "#4b96cd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.636,
    height: 14.175,
    rx: 0.818,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.636,
    height: 13.175,
    rx: 0.318,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 2.217,
    cy: 2.217,
    r: 2.217,
    transform: "translate(0 5.308)",
    fill: "#4c96ce"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9203",
    "data-name": "Group 9203",
    transform: "translate(6.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9202-2",
    "data-name": "Group 9202",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3231-2",
    "data-name": "Rectangle 3231",
    transform: "translate(1.699)",
    fill: "#4c96ce",
    stroke: "#4b96cd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.636,
    height: 14.175,
    rx: 0.818,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.636,
    height: 13.175,
    rx: 0.318,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69-2",
    "data-name": "Ellipse 69",
    cx: 2.217,
    cy: 2.217,
    r: 2.217,
    transform: "translate(0 0.875)",
    fill: "#4c96ce"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9204",
    "data-name": "Group 9204",
    transform: "translate(13.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9202-3",
    "data-name": "Group 9202",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3231-3",
    "data-name": "Rectangle 3231",
    transform: "translate(1.147)",
    fill: "#4c96ce",
    stroke: "#4b96cd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.636,
    height: 14.175,
    rx: 0.818,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.636,
    height: 13.175,
    rx: 0.318,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69-3",
    "data-name": "Ellipse 69",
    cx: 2.217,
    cy: 2.217,
    r: 2.217,
    transform: "translate(0 8.854)",
    fill: "#4c96ce"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.5eba8a9bcc75b480311dd4374e61a5c3.svg";
export { ForwardRef as ReactComponent };